module.exports = __webpack_public_path__ + "static/sign.6a7c925f.png";